import {
  FollowType,
  FollowedDepartmentsResponse,
} from '@bonhams1793/bonhams-typescript'

import { BonhamsCookies } from '@nx/global-types'
import { logger } from '@nx/utils/logger'

import { getFollowedByType } from '../followApi'

export async function getFollowedDepartments(
  userId: number,
  cookies: BonhamsCookies,
  baseUrl: string
): Promise<FollowedDepartmentsResponse['sDepartment'][]> {
  try {
    const response = await getFollowedByType<FollowedDepartmentsResponse[]>({
      userId,
      type: FollowType.department,
      cookies,
      baseURL: baseUrl,
    })

    return response.data.map((item) => item.sDepartment)
  } catch (error) {
    logger.error(error, `Could not fetch department likes for user ${userId}`)
    return []
  }
}
